import React, { useState } from "react";
import { DataListComponent } from "../../../Component/DataList/DataListComponent";
import ListFilter from "../../../Component/FilterListUi/ListFilter";
import { ResultSortBy } from "../../../Component/ResultSortBy/ResultSortBy";
import { RESULTS_FIELDS } from "../constant";
import styles from "../ResumePage.module.css";

export const SearchResultsSection = ({
  searchData,
  isLoading,
  filterOptions,
  setFilterOptions,
  selectedSort,
  onSearch,
  metadata,
  groupBy,
  setGroupBy,
  userBookmarks,
  onBookmarkToggle
}) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [checkedValue, setCheckedValue] = useState(false);

  // No search data at all - show initial message
  if (!searchData && !isLoading) {
    return (
      <div className={styles.noSearchResults}>
        <p>Click "Apply" to search for jobs matching your resume keywords</p>
      </div>
    );
  }

  // Error state
  if (searchData?.error) {
    return (
      <div className={styles.searchError}>
        <h3>Search failed</h3>
        <p>{searchData.error}</p>
        <p>Please try again</p>
      </div>
    );
  }

  const {
    results = [],
    filters = {},
    pagination,
    total = 0,
    searchPhrase = "",
    currentPage = 1,
    isGrouped = false,
  } = searchData || {};

  const totalSearchPages = pagination?.total_pages || 0;

  return (
    <div className={styles.searchResultsSection}>
      <div className={styles.resultsWrapper}>
        {/* ListFilter - visible but disabled during loading */}
        <div className={`${styles.filterSection} ${isLoading ? styles.filterSectionDisabled : ""}`}>
          <ListFilter
            filters={filters}
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
            handleSearch={onSearch}
            counts={{}}
            setCheckedValue={setCheckedValue}
            setOpenFilter={setOpenFilter}
            openFilter={openFilter}
            metadata={metadata}
            searchValue={searchPhrase}
            currentPage={currentPage}
            setCurrentPage={(page) => onSearch(searchPhrase, page, true)}
            groupBy={groupBy}
            setGroupBy={setGroupBy}
          />
        </div>

        <div className={styles.resultsContent}>
          {/* Results Header */}
          <div className={styles.resultsHeader}>
            <div className={styles.resultsInfo}>
              {isLoading ? (
                <p className={styles.resultsText}>
                </p>
              ) : results?.length > 0 ? (
                <div>
                  <p className={styles.resultsText}>
                    <b>{total} jobs found.</b>
                  </p>
                </div>
              ) : (
                <p className={styles.resultsText}>No results found</p>
              )}
            </div>

            {/* Sort dropdown - disabled during loading */}
            {metadata?.sortby?.length > 0 && (
              <div className={`${styles.sortbyDropdown} ${isLoading ? styles.sortbyDisabled : ""}`}>
                <ResultSortBy
                  sortby={metadata.sortby}
                  selectedSort={selectedSort}
                  onChange={(value) => {
                    if (!isLoading) {
                      onSearch(searchPhrase, currentPage, true, value);
                    }
                  }}
                />
              </div>
            )}
          </div>

          {/* Loading indicator */}
          {isLoading && (
            <div className={styles.loadingOverlay}>
              <div className={styles.loadingSpinner}></div>
              <p>Searching...</p>
            </div>
          )}

          {/* Results List */}
          <div className={isLoading ? styles.resultsListLoading : styles.resultsList}>
            {results?.length === 0 && !isLoading ? (
              <div className={styles.noResultsFound}>
                <p>No jobs found matching your keywords</p>
                <p>Try adding different keywords and search again</p>
              </div>
            ) : results?.length > 0 ? (
              <DataListComponent
                dataListView={results}
                currentPage={currentPage}
                setCurrentPage={(newPage) => {
                  if (!isLoading) {
                    onSearch(searchPhrase, newPage, true);
                  }
                }}
                searchedKey={searchPhrase}
                resultsFields2={RESULTS_FIELDS}
                searchLoading={isLoading}
                totalSearchPages={totalSearchPages}
                groupBy={isGrouped}
                metadata={metadata}
                userBookmarks={userBookmarks}
                onBookmarkToggle={onBookmarkToggle}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};